<template>
  <SectionCard
    id="advantage"
    :class="isPcFlag ? 'product-advantage-pc' : 'product-advantage-h5'"
    :isPcFlag="isPcFlag"
    title="高级版功能亮点"
  >
    <div class="advantage-content" v-if="isPcFlag">
      <ul class="tab_title">
        <li v-for="(v, i) in dataList" :class="m == i ? 'active' : ''" @click="m = i" :key="i.title">{{ v.title }}</li>
      </ul>
      <!-- 内容 -->
      <div class="tab_content">
        <div class="content-item" v-for="(v, i) in dataList" v-show="m == i" :key="i">
          <div class="title">{{ v.title }}</div>
          <div class="desc" v-if="v.descOne">
            <span>{{ v.descOne }}</span>
            <span class="num">{{ v.num }}</span>
            <span>{{ v.descTwo }}</span>
          </div>
          <div class="desc" v-else>{{ v.desc }}</div>
          <img class="img" :src="v.img" alt="" />
        </div>
      </div>
    </div>
    <div class="h5-advantage-content" v-else>
      <div class="content-item" v-for="(item, index) in dataList" :key="index" @click="activeItem(index)">
        <div class="title" :class="activeIndex[index] ? 'active-item' : ''">
          <p class="text">{{ item.title }}</p>
          <img class="icon" src="@/assets/images/landing-signet/h5_bottom.png" v-show="!activeIndex[index]" alt="" />
          <img class="icon" src="@/assets/images/landing-signet/h5_top.png" v-show="activeIndex[index]" alt="" />
        </div>
        <div class="content-box" v-show="activeIndex[index]">
          <div class="desc" v-if="item.descOne">
            <span>{{ item.descOne }}</span>
            <span class="num">{{ item.num }}</span>
            <span>{{ item.descTwo }}</span>
          </div>
          <div class="desc" v-else>{{ item.desc }}</div>

          <img class="img" :src="item.img" alt="" />
        </div>
      </div>
    </div>
  </SectionCard>
</template>

<script>
export default {
  props: {
    isPcFlag: Boolean, // 是Pc还是H5
    dataList: Array,
  },
  components: {
    SectionCard: () => import('@/components/basics/SectionCard.vue'),
  },
  data() {
    return {
      m: 0,
      activeIndex: [true],
    }
  },
  methods: {
    activeItem(index) {
      this.activeIndex[index] = !this.activeIndex[index]
      this.activeIndex = [...this.activeIndex]
    },
  },
}
</script>

<style lang="less" scoped>
.basisDisplay(@justify, @align) {
  display: flex;
  justify-content: @justify;
  align-items: @align;
}

.columnDisplay(@justify, @align) {
  display: flex;
  flex-direction: column;
  justify-content: @justify;
  align-items: @align;
}

// pc样式
.product-advantage-pc {
  padding-bottom: 121px !important;
  background-image: url('../../../assets/images/sem-pro/pre_high_light/pre_high_bg.png') !important;
  background-size: cover;
  .advantage-content {
    background-color: #fff;
    .basisDisplay(center, center);
    border-radius: 4px;
    border: 2px solid #ececec;

    .tab_title {
      width: 360px;

      li {
        width: 100%;
        height: 91px;
        margin-bottom: 14px;
        background: #f1f2f5;
        box-shadow: 0px 4px 7px 0px #ffffff;
        border-radius: 4px;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        line-height: 28px;
        .basisDisplay(center, center);
      }

      li:last-child {
        margin-bottom: 0;
      }

      li:hover {
        cursor: pointer;
      }

      li.active {
        background: linear-gradient(270deg, #e63740 0%, #ff8866 59%, #fff3c7 100%);
        color: #ffffff;
      }
    }

    .tab_content {
      width: 960px;
      padding: 40px 53px 19px 38px;

      .content-item {
        width: 858px;
        height: 512px;
        .title {
          width: 100%;
          font-size: 20px;
          line-height: 28px;
          text-align: center;
          font-weight: 500;
        }

        .desc {
          width: 100%;
          font-size: 14px;

          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
          line-height: 20px;
          margin: 20px 0;
          text-align: center;
        }
      }

      img {
        width: 960px;
      }
    }
  }
}
</style>
